<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='19'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;height:30px;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加入库信息</el-button>
            <el-button type="primary" size="mini" round plain @click="downloadht">入库模板下载</el-button>
            <el-button type="primary" size="mini" round plain @click="Uploadorder()" icon="el-icon-upload2">入库信息EXCEl上传</el-button>
            <el-button type="primary" size="mini" round plain @click="Export()" icon="el-icon-download">入库信息导出</el-button>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row class="rukustyle1">
              <el-col :span="4">
                <div class="grid-content1 bg-purple">入库单数</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content1 bg-purple">入库产品数量</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content1 bg-purple">入库产品价格</div>
              </el-col>
              <el-col :span="5">
                <el-date-picker
                  v-model="addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectOperationTime"
                  size="small"
                  style="width: 100%;"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="5" style="margin-left: 10px;">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="请输入名称、规格" class="filter-item">
                  <el-button slot="append" @click="search">搜索</el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row class="rukustyle2">
              <el-col :span="4">
                <div class="grid-content2 bg-purple">
                  <count-to :start-val="0" :end-val="num_in_order" :duration="2600" :decimals="0" class="card-panel-num" style="font-size:16px;" />
                  <span>单</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content2 bg-purple">
                  <count-to :start-val="0" :end-val="num_in_product" :duration="2600" :decimals="0" class="card-panel-num" style="font-size:16px;" />
                  <span>件</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content2 bg-purple">
                  <count-to :start-val="0" :end-val="price_in_product" :duration="2600" :decimals="3" class="card-panel-num" style="font-size:16px;" />
                  <span>元</span>
                </div>
              </el-col>
              <el-col :span="5" style="margin-top: 4px;">
                <el-select v-if="current_user.id == 2 || current_user.id == 100" v-model="listQuery.user_id" placeholder="用户仓库" clearable @change="selectOperationTime" size="small" style="width: 100%">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
              </el-col>
            </el-row>
            <el-row style="position: static;margin-top: 8px;">
              <el-col :span="24" class="task">
                <el-table ref="singleTable" :data="list" border stripe v-loading="qyloading" style="width: 100%">
                  <el-table-column align="center" type="selection" width="50"></el-table-column>
                  <el-table-column align="center" label="日期">
                    <template slot-scope="scope">
                      <span>{{ scope.row.addtime.substr(0,10) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="title" label="名称"></el-table-column>
                  <el-table-column align="center" prop="specification" label="规格"></el-table-column>
                  <el-table-column align="center" prop="units" label="单位" width="60"></el-table-column>
                  <el-table-column align="center" prop="number" label="数量" width="60"></el-table-column>
                  <el-table-column align="center" prop="tax_price" label="单价"></el-table-column>
                  <el-table-column align="center" prop="total_price" label="总价"></el-table-column>
                  <el-table-column align="center" prop="url" label="货品渠道">
                    <template slot-scope="scope">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:500px" v-if="scope.row.url" class="set-popper">{{ scope.row.url }}
                            <el-link :href="getUrl(scope.row.url)" type="primary" target="_blank">前往</el-link>
                          </div>
                        </template>
                        <div slot="reference" class="set-content">
                          {{ scope.row.url }}
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="remark" label="备注">
                    <template slot-scope="scope">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:500px" v-if="scope.row.remark" class="set-popper" v-html="scope.row.remark.replace(/\n/g, '<br>')"></div>
                        </template>
                        <div slot="reference" class="set-content">
                          {{ scope.row.remark }}
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="90">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该信息吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getBackupWarehouseList" :pageSizes="[10, 20, 30, 40, 50]"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="入库信息编辑" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="title">
              <el-input v-model="formData.title" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格">
              <el-input v-model="formData.specification" placeholder="请输入规格"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="数量" prop="number">
              <el-input v-model="formData.number" placeholder="请输入数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位" prop="units">
              <el-input v-model="formData.units" placeholder="请输入单位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单价" prop="tax_price">
              <el-input-number v-model="formData.tax_price" size="small" :precision="3" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="货品渠道">
              <el-input v-model="formData.url" placeholder="请输入货品渠道" clearable>
                <el-button slot="append" @click="copyText(formData.url)">复制</el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日期">
              <el-date-picker type="datetime" placeholder="选择日期时间" v-model="formData.addtime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" :clearable="false"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" :rows="4" v-model="formData.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBackupWarehouse()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="入库信息EXCEl上传" :visible.sync="dialogOrderVisible" width="20%">
      <el-form :model="formOrderData" :rules="ruless" ref="FormOrder" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="上传文件" prop="filename">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1">
                <el-button slot="trigger" size="small" type="primary">上传模板文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="importBackupWar()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="入库管理说明" :visible.sync="dialogVisible" width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/backupWarehouse'
import busOrders from '@/api/businessOrders'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import CountTo from 'vue-count-to'

export default {
  name: 'backupWarehouse',
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_backup_warehouse',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 10,
        order: 'addtime',
        page: 1,
        sort: 'DESC'
      },
      dialogFormVisible: false,
      dialogOrderVisible: false,
      locktype: false,
      formData: {
        id: null,
        addtime: new Date(),
        title: '',
        specification: '',
        number: 1,
        units: '',
        tax_price: '',
        url: '',
        remark: '',
        is_delete: 1
      },
      formOrderData: {
        filename: ''
      },
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        number: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        tax_price: [{ required: true, message: '请输入单价', trigger: 'blur' }]
      }, // 上传订单
      ruless: {
        filename: [{ required: true, message: '请上传模板文件', trigger: 'change' }]
      },
      visible: false,
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240422/6687fd0195ca2376df44e5d3201a79b3.png',
        'https://serv.nmzp.com/uploads/1/image/20240422/edd1ff9871497b4d7cf9514d4211d323.png'
      ],
      primary_key: 'id',
      addtimeBTTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      optionsUserList: [],
      num_in_order: 0,
      num_in_product: 0,
      price_in_product: 0
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getBackupWarehouseList()
    this.getUserList()
  },
  methods: {
    getBackupWarehouseList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      api.getBackupWarehouseList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.num_in_order = response.data.total
        this.num_in_product = Number(response.data.num_in_product)
        this.price_in_product = Number(response.data.price_in_product)
        this.qyloading = false
      })
    },
    downloadht () {
      window.open('https://serv.nmzp.com/uploads/doexcel/NMZPBACKUP.xlsx')
    },
    importBackupWar () {
      this.$refs['FormOrder'].validate((valid) => {
        if (valid) {
          this.formOrderData.user_id = this.current_user.id
          api.importBackupWar(this.formOrderData).then((response) => {
            if (response.code === 20000) {
              this.$notify({
                title: '成功',
                message: response.message,
                type: 'success'
              })
              this.dialogOrderVisible = false
              this.getBackupWarehouseList()
            }
          })
        }
      })
    },
    Createtask () {
      this.dialogFormVisible = true
      this.formData = {
        id: null,
        addtime: new Date(),
        title: '',
        specification: '',
        number: 1,
        units: '',
        url: '',
        tax_price: '',
        remark: '',
        is_delete: 1
      }
    },
    Uploadorder () {
      this.dialogOrderVisible = true
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.formData = Object.assign({}, row)
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        // this.formData.filename = response.message
        this.formOrderData.filename = response.savename
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.getBackupWarehouseList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    saveBackupWarehouse () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          // this.formData.user_id = this.current_user.id
          api.saveBackupWarehouse(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.getBackupWarehouseList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    search () {
      this.listQuery.page = 1
      this.getBackupWarehouseList()
    },
    // 批量导出
    Export () {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        api.export({id: ids}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else if (response.code === 30000) {
            this.$message.error(response.message)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else {
        this.$message({ message: '请选择要导出的数据', type: 'error' })
      }
    },
    copyText (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        // 尝试执行复制操作
        const success = document.execCommand('copy')
        if (success) {
          this.$message({ message: '复制成功', type: 'success' })
        } else {
          this.$message({ message: '复制失败', type: 'error' })
        }
      } catch (error) {
        this.$message({ message: error, type: 'error' })
      }
      document.body.removeChild(textarea)
    },
    getUserList () {
      busOrders.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    selectOperationTime () {
      this.listQuery.page = 1
      if (this.addtimeBTTime) {
        this.listQuery.operationBTTime = this.addtimeBTTime
      } else {
        this.listQuery.operationBTTime = []
      }
      this.getBackupWarehouseList()
    },
    getUrl (str) {
      const reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
      const strValue = str.match(reg)
      if (strValue && strValue.length > 0) {
        return strValue[0]
      }
      return null
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.el-popper{
  width:600px !important;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
.rukustyle1 {
  margin-left: -10px;
}
.rukustyle2 {
  margin-left: -10px;
}
.rukustyle1 .el-col {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}
.rukustyle2 .el-col {
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}
.rukustyle2 span {
  font-size: 14px;
}
.bg-purple {
  background: #436aa6;
}
.grid-content1 {
  padding-top: 5px;
  border-radius: 4px 4px 0 0;
  min-height: 35px;
}
.grid-content2 {
  border-radius: 0 0 4px 4px;
  min-height: 35px;
}
.set-content{
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 文本溢出时显示省略号 */
  white-space: nowrap; /* 文本不换行 */
}
</style>



// WEBPACK FOOTER //
// src/view/member/backupWarehouse.vue